module.exports = __webpack_public_path__ + "img/vitality-money-Silver.bf75cb70.svg";